enum InputTypes {
  Date = 'date',
  Number = 'number',
  Search = 'search',
  Controller = 'inputComponent'
}

export default InputTypes
